var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 14.6719L19.3969 11.2751C19.7636 10.9083 20.3582 10.9083 20.7249 11.2751C21.0917 11.6418 21.0917 12.2364 20.7249 12.6031L17.3281 16L20.7249 19.3969C21.0917 19.7636 21.0917 20.3582 20.7249 20.7249C20.3582 21.0917 19.7636 21.0917 19.3969 20.7249L16 17.3281L12.6031 20.7249C12.2364 21.0917 11.6418 21.0917 11.2751 20.7249C10.9083 20.3582 10.9083 19.7636 11.2751 19.3969L14.6719 16L11.2751 12.6031C10.9083 12.2364 10.9083 11.6418 11.2751 11.2751C11.6418 10.9083 12.2364 10.9083 12.6031 11.2751L16 14.6719Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSmall);
export default __webpack_public_path__ + "static/media/close-small.c8dd4190d890bb69321cceee7ed43e89.svg";
export { ForwardRef as ReactComponent };